"use client"

import * as React from "react"
import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground",
        "border border-primary/20 bg-card/95 shadow-xs dark:border-border dark:bg-input/30 dark:shadow-none",
        "h-[42px] w-full min-w-0 rounded-md px-3.5 transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 text-left",
        "focus-visible:border-primary/45 dark:focus-visible:border-muted-foreground/40",
        "aria-invalid:border-destructive",
        className
      )}
      style={{
        lineHeight: '42px',
        fontSize: '16px',
        ...props.style
      }}
      {...props}
    />
  )
}

export { Input }
